import { Component, OnInit } from '@angular/core';
import { Factura } from 'src/app/interfaces/factura';
import { AlertController, ModalController } from '@ionic/angular';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

import { Product } from 'src/app/interfaces/product';
import { Client } from 'src/app/interfaces/client';
import { Config } from 'src/app/interfaces/config';
import { EditTableComponent } from 'src/app/components/edit-table/edit-table.component';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-facturas',
  templateUrl: './facturas.page.html',
  styleUrls: ['./facturas.page.scss'],
})
export class FacturasPage implements OnInit {
  cif: string;
  from: Date;
  to: Date;
  serieFilterCreate: string;
  serieFilter: string;

  configDoc: Config[];

  selectedTab = 'main';
  // selectedView = 'main';
  editFields = false;
  editedId: string;

  columns = [];
  columnsCreate = [];
  columnsUnsent = [];
  products: Product[] = [];
  lines = [];
  linesCreate = [];
  linesUnsent = [];

  showFactura = false;
  createdDate: Date;
  sumTotals = 0;
  sumTotalsWithIVA = 0;
  client: Client;
  factura: Factura;
  ivas: any[] = [];
  seriesFacturas: any;
  seriesLines = [];
  seriesColumns = [];
  desde: any;
  hasta: any;
  currentPage = 0;
  maxPage = 0;
  currentPageCreate = 0;
  maxPageCreate = 0;
  searchMode = false;


  constructor(private alert: AlertController,
    private rest: RestService,
    private utils: UtilsService,
    private session: SessionService,
    private modal: ModalController) { }

   ngOnInit() {
    
  }

  async ionViewWillEnter() {
    this.setColumn();
    this.setColumnCreate();
    this.setColumnUnsent();
    await this.getFacturas();
    // await this.getFacturasCreate();
    await this.getConfigs();

    console.log(this.ivas);
    console.log(this.sumTotalsWithIVA);
    this.getSeriesFacturas();
    // await this.getUnsentFacturas();
  }

  async getFacturas() {
    this.searchMode = false;
    await this.utils.showLoading();
    const result: any = await this.rest.getFacturas(this.currentPage + 1, 20);
    this.maxPage = Math.ceil((result.body.total / 20) + ((result.body.total % 20 > 0) ? 1 : 0));
    this.lines = result.body.records;
    // To round total filed to 2 decimals
    this.lines = this.lines.map(line => {
      let totalAlbarans = 0;
      line.albaran.forEach(albaran => {
        totalAlbarans += albaran.total;
      });
      const totalParsed = this.utils.parseDecimals(totalAlbarans);
      return {
        ...line,
        total: totalParsed
      }
    });
    console.log(this.lines);
    this.lines.forEach(line => {
      const time = new Date(line.fecha).toLocaleTimeString('es-ES').slice(0, -3);
      line.fecha = new Date(line.fecha).toLocaleDateString('es-ES');
      line.fecha = line.fecha + ' - ' + time;
    });
    await this.utils.hideLoading();
  }

  async openAlertMonthYear() {
    const alert = await this.alert.create({
      header: 'Elija mes y año',
      inputs: [
        {
          name: 'month',
          type: 'number',
          placeholder: 'Mes',
          value: new Date().getMonth() + 1
        },
        {
          name: 'year',
          type: 'number',
          placeholder: 'Año',
          value: new Date().getFullYear()
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Descargar ZIP',
          handler: async (data) => {
            console.log('data');
            console.log(data);
            await this.utils.showLoading('Cargando...', 4*60000);
            const resp: any = await this.rest.downloadFacturasByMonthYearHielos(data);
            // console.log(resp.body);
            await this.utils.hideLoading();
          }
        }, {
          text: 'Descargar Excel',
          handler: async (data) => {
            console.log('data');
            console.log(data);
            await this.utils.showLoading();
            const resp: any = await this.rest.getListByMonth(data.year, data.month);
            this.session.createMonthFacturas(resp.body, data.year, data.month);
            console.log(resp.body);
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  async searchCreate() {
    try {
      this.searchMode = true;
      await this.utils.showLoading('Cargando...', 60000);
      const filters: any = {};
      if (this.cif) {
        filters.cif = this.cif;
      }
      if (this.from) {
        filters.start = this.from;
      }
      if (this.to) {
        filters.end = this.to;
      }
      if (this.serieFilterCreate) {
        filters.serie = this.serieFilterCreate.slice(1);
        filters.serie = parseInt(filters.serie, 10);
      }
      // console.log('cif: ', this.cif);
      // console.log(filters);
      const resp: any = await this.rest.getAlbaranesNotFacturedGrouped(this.currentPageCreate + 1, 20, filters);
      if (resp) {
        this.linesCreate = [];
        this.maxPageCreate = Math.ceil((resp.body.total / 20) + ((resp.body.total % 20 > 0) ? 1 : 0));

        console.log(resp.body);
        const results = resp.body.records;
        if (Object.keys(results).length > 0) {
          Object.keys(results).forEach(
            elem => {
              let total = 0;
              results[elem].forEach(
                e => {
                  total += (e.total || 0);
                }
              );
              this.linesCreate.push({
                id: 111111,
                nombre: elem,
                year: new Date().getFullYear(),
                email: results[elem][0].cliente.correo,
                serie: results[elem][0].cliente.seriefacturaId,
                total,
                client: results[elem][0].cliente._id,
                address: results[elem][0].cliente.dfiscal,
                documento: results[elem][0].cliente.documento,
                pago: null,
                facturaMensual: results[elem][0].cliente.facturaMensual,
              });
            }
          );
        }
      }
      this.linesCreate.forEach(line => {
        line.total = this.parseDecimals(line.total);
      })
      await this.utils.hideLoading();
      console.log(resp);
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
    }

  }

  async getConfigs() {
    try {
      const resp: any = await this.rest.getConfigs();
      if (resp) {
        this.configDoc = resp.body;
        console.log(this.configDoc);
      }
    } catch (error) {
      console.log(error);
      await this.utils.showToast('Error cargando factura ids', 'danger', 3000);
    }
  }


  getInfoEquipos(){

    const equipo = this.client.team;
    console.log("Equipo: "+equipo);
    let msg="";
    switch(equipo) {
      case 1:
        msg = `
              <h3>Iberica de Hielo</h3>
              <p>Servicio permanente </p>
          `;
          break;

      case 2:
        msg = `
              <h3>La confianza</h3>
              <p>Servicio permanente</p>
              `;
          break;

      case 3:
        msg = `
              <h3>Cubitos de hielo cumbreño</h3>
              <p>Servicio permanente</p>
              <p>Boden Ice S.L.</p>
              <p>Calle Barca 4 28052 Madrid</p>
              <p>Tfn. 91 433 25 74</p>
              <p>hielocumbreno@gmail.com</p>
              <p><a href="https://www.cumbreno.com/">https://www.cumbreno.com/</a></p>
              `;
          break;

      case 4:
        msg = `
              <h3>Arte Hielo Esculturas</h3>
              <p>Servicio permanente</p>
              <p>Arte Hielo Esculturas S.L.</p>
              <p>C/ PORTUGAL, 54 - NAVE 44. 28840, MEJORADA DEL CAMPO. MADRID</p>
              <p>Tfn. 678 49 89 74</p>
              <p><a href="http://www.artehieloesculturas.com/">http://www.artehieloesculturas.com/</a></p>
              `;
          break;

      case 5:
        msg = `
              <h3>Cubitos de hielo Cumbreño</h3>
              <p>Servicio permanente</p>
              <p>ICE VENTURE S.L.</p>
              <p>CALLE CERAMICA 34 28038 MADRID</p>
              <p>Tfn. 914332574 - 670416700</p>
              <p><a href="http://www.cumbreno.com/">WWW.CUMBRENO.COM</a></p>
              `;
          break;

      default:
          msg = '<p>El cliente no tiene un equipo asociado</p>';
          break;
   }
    document.getElementById("equipo").innerHTML=msg;
    return msg;
  }

  async getFacturasCreate() {
    this.searchMode = false;
    this.linesCreate = [];
    // await this.utils.showLoading();
    const resp: any = await this.rest.getAlbaranesNotFacturedGrouped(this.currentPageCreate + 1, 20);
    console.log(resp.body.total);
    this.maxPageCreate = Math.ceil((resp.body.total / 20) + ((resp.body.total % 20 > 0) ? 1 : 0));
    console.log(this.maxPageCreate);
    if (resp) {
      console.log(resp.body);
      const results = resp.body.records;
      if (Object.keys(results).length > 0) {
        Object.keys(results).forEach(
          elem => {
            let total = 0;
            results[elem].forEach(
              e => {
                total += (e.total || 0);
              }
            );
            this.linesCreate.push({
              id: 111111,
              nombre: elem,
              year: new Date().getFullYear(),
              email: results[elem][0].cliente.correo,
              serie: results[elem][0].cliente.seriefacturaId,
              total,
              client: results[elem][0].cliente._id,
              address: results[elem][0].cliente.dfiscal,
              documento: results[elem][0].cliente.documento,
              pago: null,
              facturaMensual: results[elem][0].cliente.facturaMensual,
            });
          }
        );
      }
    }
    this.linesCreate.forEach(line => {
      line.total = this.parseDecimals(line.total);
    })
    // this.linesCreate = this.linesCreate.filter(elem => elem.facturaMensual === true);
    // console.log(this.linesCreate);
    // await this.utils.hideLoading();
  }

  async search(pagination = false) {
    this.searchMode = true;
    console.log('search');
    // this.paginationCreateEvent(null);
    try {
      await this.utils.showLoading();
      const filters: any = {};
      if (this.cif) {
        filters.nameOrDoc = this.cif;
      }
      if (this.desde) {
        filters.start = this.desde;
      }
      if (this.hasta) {
        filters.end = this.hasta;
      }
      if (this.serieFilter) {
        filters.serieFilter = this.serieFilter;
      }
      if (Object.keys(filters).length > 0) {
        console.log(filters);
        const resp: any = await this.rest.getSearchedFacturas(this.currentPage, 20, this.cif, this.desde, this.hasta, this.serieFilter);
        console.log(resp);
        this.maxPage = Math.ceil((resp.body.total / 20) + ((resp.body.total % 20 > 0) ? 1 : 0));
        if (this.maxPage === 1) {
          this.maxPage = this.maxPage + 1;
        }
        console.log(this.maxPage);
        if (resp) {
          this.lines = resp.body.records;

          this.lines = this.lines.map(line => {
            let totalAlbarans = 0;
            line.albaran.forEach(albaran => {
              totalAlbarans += albaran.total;
            });
            const totalParsed = this.utils.parseDecimals(totalAlbarans);
            
            return {
              ...line,
              total: totalParsed
            }
          });
          console.log(this.lines);
          this.lines.forEach(line => {
            const time = new Date(line.fecha).toLocaleTimeString('es-ES').slice(0, -3);
            line.fecha = new Date(line.fecha).toLocaleDateString('es-ES');
            line.fecha = line.fecha + ' - ' + time;
          })
        }
        await this.utils.hideLoading();
      } else {
        await this.utils.hideLoading();
        await this.getFacturas();
      }
      if (!pagination) {
        this.currentPage = 0;
      }
      // this.maxPage = 0;

    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error en la búsqueda de facturas', 'danger', 3000);
    }
  }

  goBack() {
    this.showFactura = false;
  }

  async doAction(data) {
    console.log(data);
    const factura: Factura = data.line;
    if (data.action === 'delete') {
      this.deleteItem(factura);
    }
    if (data.action === 'download') {
      await this.showAlertFactura(factura);
      // await this.rest.downloadFactura(factura);
    }
    if (data.action === 'view') {
      console.log('view');
      this.factura = factura;
      this.showFactura = true;
      this.createdDate = new Date();
      await this.getProducts();
      await this.groupAlbaranesByClientId(factura.client);
    }
    if (data.action === 'edit') {
      console.log(data);
      const modal = await this.modal.create({
        component: EditTableComponent,
        componentProps: {
          siguienteId: data
        }
      });
      await modal.present();
      const result = await modal.onWillDismiss();
      if (result && result.data) {
        if (result.data !== data.line.nextId) {
          const newData = {
            nextId: result.data,
            _id: data.line._id
          }
          const resp: any = await this.rest.editConfig(newData);
          if (resp) {
            await this.utils.showToast('Editado con exito', 'success', 3000);
            this.getSeriesFacturas();
          } else {
            await this.utils.showToast('Error al editar', 'danger', 3000);
          }
        }
      }
    }
  }

  async showAlertFactura(factura: any) {
    const alert = await this.alert.create({
      header: 'Selecciona una fecha',
      message: 'Será la fecha que se muestre en la factura',
      inputs: [
        {
          name: 'date',
          type: 'date',
          value: new Date().toLocaleDateString().split('/').reverse().join('-')
        },
        {
          name: 'checkbox1',
          id: 'checkbox_generate_factura',
          type: 'checkbox',
          label: 'Generar uno nuevo',
          checked: false
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Descargar',
          cssClass: 'primary',
          handler: async (data) => {
            console.log('data');
            console.log(data);
            if (data && data.date) {
              const isNewFactura = data.checkbox1 === 'on';
              const dateSelected = new Date(data.date);
              console.log(new Date(data.date));
              await this.rest.downloadFactura(factura, dateSelected, isNewFactura);
            }
          }
        }
      ]
    });
    await alert.present();
  }

  async getProducts() {
    if (this.products.length === 0) {
      const resp: any = await this.rest.getProducts(1, 50);
      console.log(resp.body);
      this.products = resp.body.records;
    }
  }

  parseNameProduct(id: string) {
    if (this.products.length > 0) {
      let name: any = this.products.filter(elem => elem._id === id);
      if (name.length > 0) {
        name = name[0].name;
      } else {
        name = '';
      }
      return name;
    } else {
      return '';
    }
  }

  async groupAlbaranesByClientId(id: string) {
    try {
      console.log(id);
      let filters: any = {};
      if (this.from) {
        filters.start = this.from;
      }
      if (this.to) {
        filters.end = this.to;
      }
      console.log(filters);
      filters = JSON.stringify(filters);
      await this.utils.showLoading();
      // tslint:disable-next-line: max-line-length
      const resp = await this.rest.getAlbaranesByClientIdWithFilters(id, false, true, false, false, filters);
      // const resp = await this.rest.getAlbaranesByClientIdWithFilters(id, false, true, false, false, this.from ? this.from : null, this.to ? this.to : null);
      await this.utils.hideLoading();
      if (resp) {
        this.sumTotals = 0;
        this.sumTotalsWithIVA = 0;
        console.log(resp.body);
        this.factura.albaran = resp.body.filter(elem => elem._id);
        console.log(this.factura.albaran);
        if (this.factura.albaran.length > 0) {
          this.client = this.factura.albaran[0].cliente;
          this.getInfoEquipos();
          this.factura.albaran.forEach(
            (f, index) => {
              this.sumTotals += f.total;
              this.sumTotalsWithIVA += f.total;
              const aux = f.cantidad.map(elem => elem.iva);
              aux.forEach(
                (e, ind) => {
                  const onlyIvas = this.ivas.map(el => el.iva);
                  if (!onlyIvas.includes(e) && e > 0 && f.cantidad[ind].unit > 0) {
                    this.ivas.push({
                      iva: e,
                      total: ((f.cantidad[ind].unit * f.cantidad[ind].price * e) / 100)
                    });
                    this.sumTotalsWithIVA += ((f.cantidad[ind].unit * f.cantidad[ind].price * e) / 100);
                  } else {
                    const elem = onlyIvas.indexOf(e);

                    if (e > 0 && this.ivas[elem] && f.cantidad[ind].unit) {
                      this.ivas[elem].total += ((f.cantidad[ind].unit * f.cantidad[ind].price * e) / 100);
                      this.sumTotalsWithIVA += ((f.cantidad[ind].unit * f.cantidad[ind].price * e) / 100);
                    }
                  }
                }
              );
            }
          );
        }
      }
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
    }
  }

  async deleteItem(factura: Factura) {
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar factura ' + factura.documento,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            console.log('Item to remove!!!');
            await this.utils.showLoading();
            await this.rest.deleteFactura(factura._id);
            const albaranes = factura.albaran.map(elem => elem.id);
            console.log(factura.albaran);
            await this.rest.updateAlbaranesFacturados(factura.albaran, false);
            let aux: any = this.configDoc.filter(elem => elem.serie === factura.serie);
            if (aux && aux.length > 0) {
              aux = aux[0];
              aux.removedIds.push(factura.id);
              aux.removedIds = aux.removedIds.sort((a, b) => a - b);
              await this.rest.editConfig(aux);
            }
            this.getFacturas();
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  async createFactura() {
    await this.utils.showLoading();
    try {
      this.factura.total = this.sumTotalsWithIVA.toString();
      const albaranes = this.factura.albaran.map(elem => elem.id);
      
      let aux: any = this.configDoc.filter(elem => elem.serie === this.factura.serie.toString());
      if (aux && aux.length > 0) {
        aux = aux[0];
        if (aux.removedIds.length > 0) {
          this.factura.id = aux.removedIds[0];
          aux.removedIds.shift();
        } else {
          this.factura.id = aux.nextId;
          aux.nextId += 1;
        }
        // this.factura.id = this.factura.id.toString();
        this.factura.albaran.forEach(
          albaran => {
            albaran.cliente = albaran.cliente._id;
          }
        );

        this.factura.fecha = new Date();
        this.factura.comment = '';
        this.factura.enviada = true;
        console.log(this.factura);
        await this.rest.createFactura(this.factura);
        await this.rest.updateAlbaranesFacturados(albaranes, true);
        await this.rest.editConfig(aux);
        // TODO: Call to endpoint to generatePDF and return it
        await this.utils.hideLoading();
        await this.utils.showToast('Factura creada correctamente', 'success', 3000);
        this.goBack();
        await this.refreshPage();
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('El cliente no tiene definida una serie, por favor definalá para poder crear la factura.',
          'danger', 3000);
      }
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error al guardar factura', 'danger', 3000);
    }
    // const node = document.getElementById('factura');

    // domtoimage.toPng(node, { bgcolor: '#fff' }).then((dataUrl) => {
    //   let img;
    //   let filename;
    //   let newImage;
    //   img = new Image();
    //   img.src = dataUrl;
    //   newImage = img.src;

    //   img.onload = () => {

    //     const pdfWidth = img.width;
    //     const pdfHeight = img.height;

    //     let doc = new jsPDF();

    //     if (pdfWidth > pdfHeight) {
    //       doc = new jsPDF('l', 'px', [pdfWidth, pdfHeight]);
    //     } else {
    //       doc = new jsPDF('p', 'px', [pdfWidth, pdfHeight]);
    //     }

    //     const width = doc.internal.pageSize.getWidth();
    //     const height = doc.internal.pageSize.getHeight();

    //     doc.addImage(newImage, 'PNG', 10, 10, width, height);
    //     filename = 'mypdf_' + '.pdf';
    //     doc.save(filename);
    //   };
    // })
    //   .catch((error) => {
    //     console.error(error);
    //   });
  }

  async showAlertConfirm() {
    const alert = await this.alert.create({
      header: '¿Estás seguro?',
      message: 'Se enviarán todas las facturas que queden por enviar.',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            console.log('Send all facturas left to send');
            await this.sendAll();
          }
        }
      ]
    });
    await alert.present();
  }

  async sendAll() {
    try {
      await this.utils.showLoading();
      const resp = await this.rest.sendRemainingFacturas();
      await this.utils.hideLoading();
      if (resp) {
        await this.utils.showToast('Facturas enviadas correctamente', 'success');
      } else {
        await this.utils.showToast('Error al intentar enviar facturas', 'danger');
      }
    } catch (error) {
      await this.utils.hideLoading();
      console.log(error);
      await this.utils.showToast('Error al intentar enviar facturas', 'danger');
    }
  }

  setColumn() {
    this.columns = [
      {
        field: 'id',
        name: 'id',
        width: 5
      },
      {
        field: 'nombre',
        name: 'nombre',
        width: 10
      },
      {
        field: 'documento',
        name: 'CIF',
        width: 12
      },
      {
        field: 'serie',
        name: 'serie',
        width: 3
      },
      {
        field: 'year',
        name: 'año',
        width: 5
      },
      {
        field: 'fecha',
        name: 'fecha',
        width: 8
      },
      {
        field: 'total',
        name: 'total',
        width: 8
      },
      {
        field: 'pago',
        name: 'Fecha pago',
        width: 8
      },
      {
        field: 'comment',
        name: 'Comentario',
        width: 10
      },
      {
        field: 'action',
        name: 'acciones rápidas',
        width: 10,
        actions: [
          {
            type: 'delete'
          },
          {
            type: 'download'
          }
        ]
      }
    ];
  }
  setColumnCreate() {
    this.columnsCreate = [
      {
        field: 'nombre',
        name: 'Nombre',
        width: 10
      },
      {
        field: 'email',
        name: 'Email',
        width: 15
      },
      {
        field: 'serie',
        name: 'serie',
        width: 4
      },
      {
        field: 'total',
        name: 'total',
        width: 7
      },
      {
        field: 'numero',
        name: 'Nº factura',
        width: 7
      },
      {
        field: 'action',
        name: 'acciones rápidas',
        width: 6,
        actions: [
          {
            type: 'view'
          }
        ]
      }
    ];
  }
  setColumnUnsent() {
    this.columnsUnsent = [
      {
        field: 'id',
        name: 'id',
        width: 10
      },
      {
        field: 'nombre',
        name: 'nombre',
        width: 15
      },
      {
        field: 'documento',
        name: 'CIF',
        width: 15
      },
      {
        field: 'serie',
        name: 'serie',
        width: 5
      },
      {
        field: 'year',
        name: 'año',
        width: 5
      },
      {
        field: 'fecha',
        name: 'fecha',
        width: 10
      },
      {
        field: 'total',
        name: 'total',
        width: 10
      },
      {
        field: 'pago',
        name: 'Fecha pago',
        width: 5
      },
      {
        field: 'comment',
        name: 'Comentario',
        width: 10
      },
      {
        field: 'action',
        name: 'acciones rápidas',
        width: 10,
        actions: [
          {
            type: 'delete'
          },
          {
            type: 'doble_next'
          }
        ]
      }
    ];
  }

  parseDecimals(num: number) {
    if (isNaN(num)) {
      const myNum = 0;
      // num = 0;
      return (parseFloat(myNum.toString())).toFixed(2);
    } else
      return (parseFloat(num.toString())).toFixed(2);
  }

  async getSeriesFacturas() {
    const result: any = await this.rest.getConfigs()
    this.seriesFacturas = result.body;
    console.log(this.seriesFacturas);
    this.seriesLines = this.seriesFacturas;
    for (const factura of this.seriesFacturas) {
      factura.serie = 'H' + factura.serie
    }

    this.seriesColumns = [
      {
        field: 'serie',
        name: 'serie',
        width: 10
      }, {
        field: 'nextId',
        name: 'Siguiente Id',
        width: 10
      },
      {
        field: 'removedIds',
        name: 'Ids Eliminados',
        width: 10
      }, {
        field: 'action',
        name: 'acciones rápidas',
        width: 10,
        actions: [
          {
            type: 'edit'
          }
        ]
      }
    ];
  }
  /*async getUnsentFacturas() {
    await this.utils.showLoading();
    const result: any = await this.rest.getUnsentFacturas();
    this.linesUnsent = result.body;
    // To round total filed to 2 decimals
    this.linesUnsent = this.linesUnsent.map(lineUnsent => {
      const totalParsed = this.utils.parseDecimals(lineUnsent.total);
      return {
        ...lineUnsent,
        total: totalParsed
      }
    });
    console.log(this.linesUnsent);
    this.linesUnsent.forEach(lineUnsent => {
      const time = new Date(lineUnsent.fecha).toLocaleTimeString('es-ES').slice(0, -3);
      lineUnsent.fecha = new Date(lineUnsent.fecha).toLocaleDateString('es-ES');
      lineUnsent.fecha = lineUnsent.fecha + ' - ' + time;
    })
    await this.utils.hideLoading();
  }*/

  async getUnsentFacturas() {
    // await this.utils.showLoading();
    const result: any = await this.rest.getUnsentFacturas();
    this.linesUnsent = result.body;
    // To round total filed to 2 decimals
    this.linesUnsent = this.linesUnsent.map(line => {
      let totalAlbarans = 0;
      line.albaran.forEach(albaran => {
        totalAlbarans += albaran.total;
      });
      const totalParsed = this.utils.parseDecimals(totalAlbarans);
      // const totalParsed = this.utils.parseDecimals(line.total);
      return {
        ...line,
        total: totalParsed
      }
    });
    console.log(this.linesUnsent);
    this.linesUnsent.forEach(line => {
      const time = new Date(line.fecha).toLocaleTimeString('es-ES').slice(0, -3);
      line.fecha = new Date(line.fecha).toLocaleDateString('es-ES');
      line.fecha = line.fecha + ' - ' + time;
      line.total = this.parseDecimals(line.total);
    })
    // await this.utils.hideLoading();
  }

  async pagination(data: any) {
    console.log('pagination data', data);
    const factura: Factura = data.line;
    if (data.action === 'delete') {
      this.deleteItem(factura);
    }
    if (data.action === 'download') {
      await this.showAlertFactura(factura);
    }
    if (data.action === 'view') {
      console.log('view');
      this.factura = factura;
      this.showFactura = true;
      this.createdDate = new Date();
      await this.getProducts();
      await this.groupAlbaranesByClientId(factura.client);
    }
    if ((this.currentPage + data >= 0) && (this.currentPage + data <= this.maxPage)) {
      this.currentPage += data;
    }
    console.log('currentPage: ', this.currentPage);
    if (!this.searchMode) {
      this.getFacturas();
    } else {
      this.search(true);
    }
  }
  async paginationCreateEvent(data: any) {
    console.log(data);
    const factura: Factura = data.line;
    if (data.action === 'delete') {
      this.deleteItem(factura);
    }
    if (data.action === 'download') {
      await this.showAlertFactura(factura);
    }
    if (data.action === 'view') {
      console.log('view');
      this.factura = factura;
      this.showFactura = true;
      this.createdDate = new Date();
      await this.getProducts();
      await this.groupAlbaranesByClientId(factura.client);
    }
    if ((this.currentPageCreate + data >= 0) && (this.currentPageCreate + data <= this.maxPageCreate)) {
      this.currentPageCreate += data;
    }
    if (!this.searchMode) {
      this.getFacturasCreate();
    } else {
      this.searchCreate();
    }
  }

  clearFilters() {
    this.from = null;
    this.to = null;
    this.serieFilterCreate = null;
    this.serieFilter = null;
    this.desde = null;
    this.hasta = null;
  }

  async refreshPage() {
    this.clearFilters();
    await this.getFacturas();
    // await this.getFacturasCreate();
    await this.getConfigs();
    // await this.getUnsentFacturas();
  }

  sendFacturas() {
    this.confirmSendFacturas();
  }
  async confirmSendFacturas() {
    const alert = await this.alert.create({
      header: 'Enviar facturas en falta?',
      message: '¡Atención! Seran enviadas las facturas que mailgun no ha podido enviar del mes anterior. Esa action mejor realizar a los primeros dias del mes sino podran ser envidas facturas erroneas del mes actual',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Enviar',
          handler: async () => {
            const result = await this.rest.sendUnsendedFacturas();
            console.log(result);
            this.utils.showToast('Facturas envidas, necesario validar en mailgun si han sido todas envidas');
          }
        }
      ]
    });
  
    await alert.present();
  }
}
